import { injectable } from "inversify";
import { StoredPreferences } from "../../model/storedPreferences/StoredPreferences";
import { Storage, Preferences } from "../../utils/storage";

export interface PreferencesStorage {
  getPreferences(): StoredPreferences;
  saveVolumePreference(volume: number): void;
  saveSubtitlesPreference(isDisplayed: boolean, language: string): void;
  saveIsDebugModeOpen(isDebugModeOpen: boolean): void;
}

@injectable()
export class PreferencesStorageImpl implements PreferencesStorage {
  private static VOLUME_COOKIE_NAME = "vintomVolume";
  private static SUBTITLES_DISPLAYED_COOKIE_NAME = "vintomSubtitlesDisplayed";
  private static LANGUAGE_COOKIE_NAME = "vintomLanguage";

  getPreferences(): StoredPreferences {
    let volume;
    try {
      const volumeStr = Storage.readCookie(PreferencesStorageImpl.VOLUME_COOKIE_NAME);
      volume = volumeStr && Number(volumeStr);

      if (isNaN(volume) || !volume) {
        volume = undefined;
      } else if (volume !== undefined) {
        volume = Math.max(0, Math.min(1, parseFloat(volume)));
      }
    } catch {
      // ignore
    }

    let isSubtitlesDisplayed: boolean;
    try {
      const isSubtitlesDisplayedStr = Storage.readCookie(PreferencesStorageImpl.SUBTITLES_DISPLAYED_COOKIE_NAME);
      isSubtitlesDisplayed = isSubtitlesDisplayedStr && isSubtitlesDisplayedStr.toLowerCase() === "true";
    } catch {
      // ignore
    }

    const language = Storage.readCookie(PreferencesStorageImpl.LANGUAGE_COOKIE_NAME);
    const isDebugModeOpen = Preferences.read("isDebugModeOpen", false);
    return new StoredPreferences(volume, isSubtitlesDisplayed, language, isDebugModeOpen);
  }

  saveVolumePreference(volume: number): void {
    Storage.setCookie(PreferencesStorageImpl.VOLUME_COOKIE_NAME, volume && volume.toString());
  }

  saveSubtitlesPreference(isDisplayed: boolean, language: string): void {
    Storage.setCookie(PreferencesStorageImpl.SUBTITLES_DISPLAYED_COOKIE_NAME, `${isDisplayed}`);
    Storage.setCookie(PreferencesStorageImpl.LANGUAGE_COOKIE_NAME, language);
  }

  saveIsDebugModeOpen(isDebugModeOpen: boolean): void {
    Preferences.set("isDebugModeOpen", isDebugModeOpen);
  }
}
